module.exports = __webpack_public_path__ + "img/qr-code.c8fda15f.svg";